const riot = require('riot');

riot.tag2('page-index', '<div class="s-full f fh"> <div> <h1 class="text-primary text-center">Repro Incentive</h1> </div> </div>', 'page-index,[data-is="page-index"]{display:block}', '', function(opts) {
    this.preload = () => {

    };

    this.head = () => {
      return {
        title: 'Repro Incentive',
      };
    };
});